import { CellContext } from "@tanstack/react-table";
import classNames from "classnames";
import { useCallback, useState, memo } from "react";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { ClassFilter } from "../../Class/ClassFilter/ClassFilter";

export const ClassesCell = memo(
    ({ row }: CellContext<TransactionListItemDto, any>) => {
        const [hasOpenedClassFilter, setHasOpenedClassFilter] = useState(false);

        // NOTE: for optimistic update
        const [localClasses, setLocalClasses] = useState(
            row.original.classAssignments?.map((c) => c.classId) ?? [],
        );

        const onClassFilterEnter = useCallback(() => {
            setHasOpenedClassFilter(true);
        }, []);

        const onClassFilterExit = useCallback(() => {
            setHasOpenedClassFilter(false);
        }, []);

        return (
            <td className="transaction-list-item__class">
                <span
                    className={classNames(
                        "transaction-list-item__class__content",
                        {
                            "transaction-list-item__class__content--always-visible":
                                hasOpenedClassFilter ?? localClasses.length > 0,
                        },
                    )}
                >
                    <ClassFilter
                        onShow={onClassFilterEnter}
                        onHide={onClassFilterExit}
                        selectedClasses={localClasses}
                        onChange={(classIds) => {
                            setLocalClasses(classIds);
                        }}
                        behaviour={{
                            selectedParentClassIncludesAllChildren: false,
                            canSelectOnlyOneClassInTheSameRoot: true,
                        }}
                    />
                </span>
            </td>
        );
    },
);
